export default ['MP4', 'M4V', 'MOV', 'WEBM', 'WMV', 'MXF'] as const;
